<template>
    <rkm-overlay>
        <rkm-layout-body title="Relatório de documentos não assinados">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import List from '@/components/pronto-atendimento/relatorio-documento-nao-assinado/List'

export default {
    components: {
        List,
    },
}
</script>